module.exports = __webpack_public_path__ + "media/images/img-detail2-5afc3de57745a067016b8711350a43bb.jpg";